import { BaseService, Service } from "/@/cool";
@Service("shootOrders")
class ShootOrders extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["composePage"] = prefix + "composePage";
		this.permission["saveModelInfo"] = prefix + "saveModelInfo";
		this.permission["getConfirmedBasicInfo"] = prefix + "getConfirmedBasicInfo";
		this.permission["page"] = prefix + "page";
		this.permission["info"] = prefix + "info";
		this.permission["view"] = prefix + "view";
		this.permission["orderAddress"] = prefix + "orderAddress";
		this.permission["preCalcHeight"] = prefix + "preCalcHeight";
		this.permission["shootPreview"] = prefix + "shootPreview";
		this.permission["shootPreviewCartoon"] = prefix + "shootPreviewCartoon";
		this.permission["checkCount"] = prefix + "checkCount";
		this.permission["checkSubjectMatch"] = prefix + "checkSubjectMatch";
		this.permission["markSubjectAuditOrder"] = prefix + "markSubjectAuditOrder";
		this.permission["markSubjectAuditPid"] = prefix + "markSubjectAuditPid";
	}
	//获取拍照订单的基础信息
	getConfirmedBasicInfo(data: any) {
		return this.request({
			url: "/getConfirmedBasicInfo",
			method: "POST",
			data
		});
	}

	// 保存模型信息
	saveModelInfo(params: any) {
		return this.request({
			url: "/saveModelInfo",
			method: "POST",
			params
		});
	}
	// 保存模型信息
	view(params: any) {
		return this.request({
			url: "/view",
			method: "GET",
			params
		});
	}
	composePage(params: any) {
		return this.request({
			url: "/composePage",

			method: "GET",
			params
		});
	}
	// 获取订单地址
	orderAddress(params: any) {
		return this.request({
			url: "/orderAddress",
			method: "GET",
			params
		});
	}

	// 身高计算
	preCalcHeight(data: any) {
		return this.request({
			url: "/preCalcHeight",
			method: "POST",
			data
		});
	}

	shootPreview(data: any) {
		return this.request({
			url: "/shootPreview",
			method: "POST",
			data
		});
	}

	shootPreviewCartoon(data: any) {
		return this.request({
			url: "/shootPreviewCartoon",
			method: "POST",
			data
		});
	}

	checkCount(data: any) {
		return this.request({
			url: "/checkCount",
			method: "POST",
			data
		});
	}

	checkSubjectMatch(data: any) {
		return this.request({
			url: "/checkSubjectMatch",
			method: "POST",
			data
		});
	}

	markSubjectAuditOrder(data: any) {
		return this.request({
			url: "/markSubjectAuditOrder",
			method: "POST",
			data
		});
	}
	markSubjectAuditPid(data: any) {
		return this.request({
			url: "/markSubjectAuditPid",
			method: "POST",
			data
		});
	}
}
export default ShootOrders;
